import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Text = styled.p`
  position: relative;
  margin-left: 54px;
  /* Styling for the Icon */
  &::before {
    content: '';
    display: ${props => (props.icon ? 'inline-block' : 'none')};
    background-image: ${({ icon }) => icon && `url(${icon})`};
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    width: 100%;
    height: 100%;
    max-width: 35px;
    max-height: 35px;

    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: -54px;
  }

  /* Styling for the Title Within a Card component @Mobile */
  &.card {
    margin: 0;
    font-weight: ${themeGet('fontWeights.medium')};
    font-size: 24px;
    line-height: 36px;
    color: ${themeGet('colors.main-text')};
    /* Styling for the Icon Within a Card component @Mobile */
    &::before {
      content: '';
      display: ${props => (props.icon ? 'block' : 'none')};
      position: static;
      transform: none;
      top: unset;
      max-width: 56px;
      max-height: 56px;
      width: 56px;
      height: 56px;
      margin: 0;
      margin-bottom: 10px;
    }
  }

  &.link-icon {
    margin: 0;
    display: flex;
    flex-direction: row;
    &::before {
      content: '';
      display: ${props => (props.icon ? 'block' : 'none')};
      position: static;
      transform: none;
      top: unset;
      width: 50px;
      height: 50px;
      margin: 20px 20px 20px 0;
    }
  }

  &.video {
    margin-left: 0px;
    &::before {
      width: 24px;
      height: 24px;
      margin-left: -30px;
    }
    &:hover {
      color: ${themeGet('colors.pc-red')};
    }
  }

  &.icon-with-text {
    margin: 0;
    margin-bottom: 1rem;
    display: flex;

    &::before {
      content: '';
      display: ${props => (props.icon ? 'block' : 'none')};
      position: static;
      transform: none;
      top: unset;
      max-width: 24px;
      max-height: 24px;
      width: 100%;
      height: 24px;
      margin: 0px 20px 20px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    /* Styling for the Title Within a Card component @Tablet */
    &.card {
      line-height: 32px;
      /* Styling for the Icon Within a Card component @Tablet */
      &::before {
        margin-bottom: 20px;
        max-width: 70px;
        max-height: 70px;
        width: 70px;
        height: 70px;
      }
    }
  }

  &.tip {
    margin-left: 54px;
    p:last-child {
      margin-left: -15px;
    }
    p {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    &::before {
      max-width: 32px;
      max-height: 32px;
      width: 32px;
      height: 32px;
      margin-left: -52px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      p:last-child {
        margin-left: 0;
      }
    }
  }

  &.faq-card {
    margin: 0;
    font-weight: ${themeGet('fontWeights.bold')};
    font-size: 18px;
    line-height: 1.33;
    color: ${themeGet('colors.main-text')};
    &::before {
      content: '';
      position: relative;
      transform: none;
      top: unset;
      width: 24px;
      height: 24px;
      margin-left: 0;
      vertical-align: middle;
    }

    strong {
      vertical-align: middle;
      margin-left: 20px;
      font-weight: ${themeGet('fontWeights.medium')};
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 20px;
      line-height: 1.4;

      strong {
        vertical-align: none;
        margin-left: 0;
      }

      &:before {
        display: block;
        margin-bottom: 32px;
        width: 40px;
        height: 40px;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 24px;
      line-height: 1.33;

      &:before {
        margin-bottom: 39px;
      }
    }
  }

  &.center {
    &:before {
      margin: 0 auto;
      margin-bottom: 10px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      &:before {
        margin-bottom: 20px;
      }
    }
  }
`;
